import websiteRatingModel from '@/components/common/stat/website-rating-model'
import {PublicHeader} from "@/components/common/index.js"
import inviteCombobox from '@/components/act/invite/invite-combobox'
import {
  TrendPics, PicResources, PicPackageDesc, PicPanel, PicPackagePanel,
} from '~/components/tupian/detail';
import PicPackagePay from '~/components/pay/pic-package-pay'

import {PaySuccessDialog, PayRetainDialog} from "@/components/payment/index.js"
import VipRenewalNotice from "@/components/common/notice/vip-renewal"
import ProfitModal from '@/components/tupian/detail/profit-modal'
import {DownloadInterceptDialog} from "@/components/material";
import CollectionRecommend from '@/components/collection/collection-recommend';
import PicPackagePayModal from '@/components/pic-package/pic-package-pay-modal'
import CompanyCertificateDialog from '@/components/company/common/certificate-dialog'
import ReceiveCompanyCouponDialog from '@/components/tupian/detail/receive-company-coupon-dialog'
import DetailInviteDown from '@/components/tupian/detail/detail-invite-down'

let mixin = {
  components:{
    websiteRatingModel,
    PublicHeader,
    inviteCombobox,
    TrendPics,
    PicResources,
    PicPackageDesc,
    PicPanel,
    PicPackagePanel,
    PicPackagePay,
    PaySuccessDialog,
    PayRetainDialog,
    VipRenewalNotice,
    ProfitModal,
    DownloadInterceptDialog,
    PicPackagePayModal,
    CompanyCertificateDialog,
    ReceiveCompanyCouponDialog,
    CollectionRecommend,
    DetailInviteDown
  }
}

export default mixin;
